export default {
  bind (el, binding, vnode) {
    function documentHandler (e) {
      if (el.contains(e.target)) {
        return false
      }
      if (binding.expression) {
        binding.value(e)
      }
    }

    el.__aidClickOutside__ = documentHandler
    document.addEventListener('click', documentHandler, false)
  },
  unbind (el, binding) {
    document.removeEventListener('click', el.__aidClickOutside__)
    delete el.__aidClickOutside__
  }
}



// WEBPACK FOOTER //
// ./src/directives/click-outside.js